import React from 'react';
import { Link as LinkType, UseLinks, TrackEvent } from '../../types';
import { Link } from './Link';
import './LinkList.scss';

interface LinkListProps {
  links: UseLinks;
  list: LinkType[];
  testId: string;
  title?: string;
  onArchivedToggle: (id: number, isArchived: boolean) => void;
  onRemove: (id: number) => void;
  onTrackEvent: TrackEvent;
}

export const LinkList: React.FC<LinkListProps> = ({
  links,
  list,
  testId,
  title,
  onRemove,
  onArchivedToggle,
  onTrackEvent,
}) => {
  let isInactive = false;
  return (
    <div className="link-list" data-testid={testId}>
      {title && <h4 className="link-list__title">{title}</h4>}
      {list.length > 0 ? (
        <ul>
          {list.map(link => {
            isInactive = isInactive || links.processingId === link.id;
            return (
              <Link
                key={link.id}
                {...link}
                isHighlighted={links.highlightedId === link.id}
                isProcessing={links.processingId === link.id}
                isInactive={isInactive}
                isInvalid={links.isInvalid[link.id]}
                onTrackEvent={onTrackEvent}
                onEdit={links.edit}
                onArchivedToggle={onArchivedToggle}
                onRemove={onRemove}
              />
            );
          })}
        </ul>
      ) : (
        <div className="link-list__empty">There are no previously generated links</div>
      )}
    </div>
  );
};
